




































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({})
export default class Modal extends Vue {
  @Prop({
    default: false
  })
  loginModal: boolean;

  beforeCreate() {
    /**
     * Add a class that hide scrollbar when modal is open
     */
    const el: any = document.getElementsByTagName("body");
    if (el !== null) el.item(0).classList.add("modal-open");
  }

  destroyed() {
    /**
     * Remove the class that hide scrollbar when modal is open
     */
    const el: any = document.getElementsByTagName("body");
    if (el !== null) el.item(0).classList.remove("modal-open");
  }
}
